/**
 * Efface les copies de session gardees pendant une prise de controle admin ou une session
 * « en tant qu'agence » (audit securite 2026-10-12).
 *
 * La deconnexion n'effacait que `access_token`, `refresh_token` et `user`. Les jetons de
 * l'admin (ou du siege) restaient dans le navigateur, et le bouton « revenir » du bandeau
 * les remettait en place sans mot de passe : la personne suivante sur ce poste retrouvait
 * la session super-admin. A appeler a chaque deconnexion demandee par l'utilisateur.
 */
const ACTING_BACKUP_KEYS = [
  'gd_impersonation',
  'gd_impersonation_original_user',
  'gd_impersonation_original_token',
  'gd_impersonation_original_refresh',
  'gd_network_acting',
  'gd_network_original_token',
  'gd_network_original_refresh',
  'gd_network_original_user',
];

export const clearActingBackups = (): void => {
  if (typeof window === 'undefined') return;
  for (const key of ACTING_BACKUP_KEYS) {
    try {
      localStorage.removeItem(key);
    } catch {
      // stockage indisponible
    }
  }
};
